import React from 'react';
import {
    Col, Row, Form, FormGroup, ControlLabel, Modal
} from 'react-bootstrap';
import Select from 'react-select';
import { mountTable, unmountTable, getTable } from '../../views/Components/JQueryTable/JQueryTableLogic.jsx';
import JQueryTableComponent from '../../views/Components/JQueryTable/JQueryTableComponent.jsx';
import { API_ROOT } from '../../variables/api-config';
import Button from '../../elements/CustomButton/CustomButton.jsx';
import ModalCargaFactura from '../Components/ModalCargaFactura.jsx';
import ModalBlockWrapper from '../Components/ModalBlockWrapper.jsx';

const dataTable = {
  headerRow: ["Proyecto", "Fecha", "Número", "Proveedor/Cliente", "Concepto", "Neto", "Tipo", "Estado", "Acciones"],
  footerRow: ["Proyecto", "Fecha", "Número", "Proveedor/Cliente", "Concepto", "Neto", "Tipo", "Estado", "Acciones"],
};

class UncusaTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      subtipoFiltro: {value: 'VENTAS', label: 'VENTAS'},
      estadoFiltro: {value: 'SOLICITADA', label: 'SOLICITADA'},
      currentFactura: null,
      modalFactura: false,
      disableEstadoFiltro: false,
    };
    this.onClickEdit = this.onClickEdit.bind(this);
    this.onClickApplyFilters = this.onClickApplyFilters.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.editFactura = this.editFactura.bind(this);
    this.onSubtipoFiltroChange = this.onSubtipoFiltroChange.bind(this)
    this.saveFactura = this.saveFactura.bind(this);
    this.filters = [{name: 'estado', value:'estado'}, {name: 'subtipo', value:'subtipo'}];
  }
  componentDidMount() {
    mountTable(API_ROOT + "/incubation/facturas-grid", "uncusaTab", this.onClickEdit, null, null, null, null, this.filters);
  }
  componentWillUnmount() {
    unmountTable('uncusaTab');
  }
  shouldComponentUpdate() {
    return true;
  }
  onClickEdit(data) {
    this.editFactura(data[8]);
  }

  editFactura(id) {
    this.props.incubationService
      .getFacturaById(id)
      .then(res => {
        this.setState({currentFactura: res.factura, modalFactura: true});
      })
      .catch(err => {
        this.props.setError(
          <div>
            Ha ocurrido un error mientras se cargaba la factura, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }

  saveFactura(factura) {
    this.props.incubationService.postFactura(factura, this.state.currentFactura.idproyectoincubacion)
      .then(res => {
        this.onClickApplyFilters();
        this.props.pushNotification('success', 'tc', 'pe-7s-check', (<div>Factura actualizada satisfactoriamente!</div>), 10);
        this.setState({modalFactura: false});
      })
      .catch(err => {
        this.props.setError(
          <div>
            Ha ocurrido un error mientras se actualizaba la información de la factura, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }

  onSubtipoFiltroChange(value) {
    this.setState({ subtipoFiltro: value });
    if (!value || value.label === 'COMPRA') {
      this.setState({ estadoFiltro: null, disableEstadoFiltro: true });
    } else {
      this.setState({ disableEstadoFiltro: false });
    }
  }

  clearFilters() {
    this.setState({estadoFiltro: null, subtipoFiltro: null});
  }
  onClickApplyFilters() {
    const table = getTable('uncusaTab');
    table.clear();
    table.ajax.reload();
    table.draw();
  }
  render() {
    const estadosList = [
      {value: 'SOLICITADA', label: 'SOLICITADA'},
      {value: 'APROBADA', label: 'APROBADA'},
    ];
    const subtipoList = [
      {value: 'VENTAS', label: 'VENTAS'},
      {value: 'COMPRA', label: 'COMPRA'},
    ];
    return(
      <div>
        <Form horizontal>
          <Row>
            <Col md={4}>
              <FormGroup>
                <Col componentClass={ControlLabel} md={6} style={{textAlign:'left', paddingTop: '7px'}}>
                  Tipo:
                </Col>
                <Col md={6}>
                  <Select
                    placeholder="Seleccione"
                    closeOnSelect={true}
                    name="type"
                    value={this.state.subtipoFiltro}
                    options={subtipoList}
                    onChange={(value) => this.onSubtipoFiltroChange(value)}
                  />
                </Col>
              </FormGroup>
            </Col>
            <Col md={5}>
              <FormGroup>
                <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                  Estado:
                </Col>
                <Col md={8}>
                  <Select
                    placeholder={this.state.disableEstadoFiltro ? 'Facturas COMPRA no tienen estado' : 'Seleccione'}
                    closeOnSelect={true}
                    name="type"
                    value={this.state.estadoFiltro}
                    options={estadosList}
                    onChange={(value) => { this.setState({estadoFiltro: value}) }}
                    disabled={this.state.disableEstadoFiltro}
                  />
                </Col>
              </FormGroup>
            </Col>
            <Col md={3}>
              <span style={{ float: 'right' }}>
                <Button onClick={this.onClickApplyFilters} bsStyle="success" fill={true}>Aplicar Filtros</Button>
                <Button onClick={this.clearFilters} bsStyle="danger" fill={true}>
                  <i className="fa fa-ban"></i>
                </Button>
              </span>
            </Col>
          </Row>
        </Form>
        <input style={{display: 'none'}} type="text" className="estado" value={JSON.stringify(this.state.estadoFiltro)} disabled />
        <input style={{display: 'none'}} type="text" className="subtipo" value={JSON.stringify(this.state.subtipoFiltro)} disabled />
        <div className="fresh-datatables">
          <JQueryTableComponent dataTable={dataTable} identifier="uncusaTab" />
        </div>
        <Modal show={this.state.modalFactura} onHide={() => this.setState({modalFactura: false, currentFactura: null})} bsSize="large">
          <ModalBlockWrapper
            content={
              <div>
                <Modal.Header closeButton>
                  <Modal.Title>{this.state.currentFactura && this.state.currentFactura.subtipo === 'VENTAS' ? 'Aprobar Factura de Venta' : 'Ver Factura de Compra'}</Modal.Title>
                </Modal.Header>
                <ModalCargaFactura
                  cancel={() => this.setState({modalFactura: false, currentFactura: null})}
                  save={(factura) => this.saveFactura(factura)}
                  tipo={this.state.currentFactura && this.state.currentFactura.subtipo} currentFactura={this.state.currentFactura}
                  readOnly={this.state.currentFactura && this.state.currentFactura.subtipo === 'COMPRA'}
                  setError={this.props.setError}
                  uncusa
                />
              </div>
            }
          />
        </Modal>
      </div>
    );
  }
}

export default UncusaTab;



// WEBPACK FOOTER //
// ./src/views/Uncusa/UncusaTab.jsx